import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
const alertVariants = tv(
  {
    base: `
      relative grid grid-cols-[0_1fr] items-start gap-y-0.5 w-full px-4 py-3 border rounded-lg text-sm
      has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] has-[>svg]:gap-x-3 [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current
    `,
    variants: {
      variant: {
        default: "bg-card text-card-foreground",
        destructive: "border-destructive/90 text-destructive bg-card [&>svg]:text-current *:data-[slot=alert-description]:text-destructive/90",
        warning: "border-(--yellow-9) bg-(--yellow-2) text-(--yellow-11)",
        success: "border-(--green-9) bg-(--green-2) text-(--green-11)",
        info: "border-(--blue-9) bg-(--blue-2) text-(--blue-11)"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
export {
  alertVariants
};
//# sourceMappingURL=index.js.map
